/**
 *  some variables
 */
let debug = false;

/**
 * hamburgers - burger menu - animation
 */
const burgerButton = document.getElementById('burger-menu-btn')

burgerButton.addEventListener('click', function () {
    burgerButton.classList.toggle('is-active')
})
